import { c as _c } from "react/compiler-runtime";
import debounce from 'lodash.debounce';
import { useLayoutEffect, useRef, useState } from 'react';
import Avatar from 'shared/components/header/components/avatar';
import { DesktopMenu } from 'shared/components/header/components/desktop-menu';
import SideMenu from 'shared/components/header/components/side-menu';
import SioButton from 'shared/components/header/components/sio-button';
import WorkspaceSelector from 'shared/components/header/components/workspace-selector';
import { DesktopLanguageSwitcher } from 'shared/components/language-switcher/desktop-language-switcher';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useActualHeaderLayoutType = () => {
  const $ = _c(5);
  const {
    data,
    mutate
  } = useSWR("header-layout-type");
  let t0;
  if ($[0] !== mutate) {
    t0 = desktop => mutate(desktop, false);
    $[0] = mutate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== data || $[3] !== t0) {
    t1 = {
      isDesktop: data,
      setIsDesktop: t0
    };
    $[2] = data;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function Header() {
  const $ = _c(11);
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLoading,
    user
  } = useUser();
  const navRef = useRef(null);
  const workspaceRef = useRef(null);
  const sideMenuRef = useRef(null);
  const desktopMenuRef = useRef(null);
  const avatarRef = useRef(null);
  const {
    setIsDesktop
  } = useActualHeaderLayoutType();
  let t0;
  if ($[0] !== setIsDesktop) {
    t0 = () => {
      const handleResize = debounce(() => {
        const nav = navRef.current;
        const desktopMenu = desktopMenuRef.current;
        const sideMenu = sideMenuRef.current;
        const avatar = avatarRef.current;
        const workspace = workspaceRef.current;
        if (!desktopMenu || !sideMenu || !nav || !avatar || !workspace) {
          return;
        }
        const showDesktopElements = () => {
          desktopMenu.classList.remove("hidden");
          avatar.classList.remove("hidden");
          workspace.classList.remove("hidden");
          desktopMenu.classList.add("flex");
          avatar.classList.add("flex");
          workspace.classList.add("flex");
          sideMenu.classList.add("hidden");
          sideMenu.classList.remove("flex");
          setIsDesktop(true);
        };
        const showMobileElements = () => {
          desktopMenu.classList.remove("flex");
          avatar.classList.remove("flex");
          workspace.classList.remove("flex");
          desktopMenu.classList.add("hidden");
          avatar.classList.add("hidden");
          workspace.classList.add("hidden");
          sideMenu.classList.remove("hidden");
          sideMenu.classList.add("flex");
          setIsDesktop(false);
        };
        if (document.body.getBoundingClientRect().width < 1024) {
          showMobileElements();
          return;
        }
        if (nav.scrollWidth > nav.offsetWidth) {
          showMobileElements();
        } else {
          showDesktopElements();
          if (nav.scrollWidth > nav.offsetWidth) {
            showMobileElements();
          }
        }
      }, 300, {
        leading: true,
        trailing: true
      });
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    $[0] = setIsDesktop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = user?.dashboardLocale;
  let t2;
  if ($[2] !== isLoading || $[3] !== t1) {
    t2 = [isLoading, t1];
    $[2] = isLoading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useLayoutEffect(t0, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SioButton />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-4">{t3}<div ref={workspaceRef} className="flex"><WorkspaceSelector /></div></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div ref={desktopMenuRef} className="ml-auto flex h-full"><DesktopMenu /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div ref={avatarRef} className="flex h-full shrink-0 items-center justify-around gap-4"><Avatar /><DesktopLanguageSwitcher /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isOpen) {
    t7 = <nav ref={navRef} className="top-0 z-10"><div className="text-background-secondary bg-[rgb(var(--background-header))] z-10 mx-auto flex h-[69px] w-full items-center justify-between gap-4 px-4 sm:px-6 md:px-14">{t4}{t5}{t6}<div ref={sideMenuRef} className="hidden"><SideMenu isOpen={isOpen} setIsOpen={setIsOpen} /></div></div></nav>;
    $[9] = isOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
export default Header;